module.exports = __webpack_public_path__ + "img/loader.ded5165a.jpg";